import { useEffect, useState } from 'react'
import type { User } from '../utils/loginUtils'
import TabSystem from './Tabs/TabSystem'
import type { Mode } from '../App'

interface MainPageProps {
  setLoggedInUser: (loggedInUser: User | null) => void
  setMode: (mode: Mode) => void
  isMobile: boolean
  user: User
}

function MainPage({ setLoggedInUser, user, setMode, isMobile }: MainPageProps) {
  const handleLogout = () => {
    localStorage.clear()
    setLoggedInUser(null)
  }

  return (
    <div>
      <TabSystem
        user={user}
        isMobile={isMobile}
        handleLogout={handleLogout}
        setMode={setMode}
      />
    </div>
  )
}

export default MainPage
